import { render, staticRenderFns } from "./ConversationCard.vue?vue&type=template&id=b3ad497e&"
import script from "./ConversationCard.vue?vue&type=script&lang=js&"
export * from "./ConversationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports